import { PaginatorOptions } from "@core/models/leave-admin/reports/paginator-options.model";

export const PAGINATOR_OPTIONS: PaginatorOptions = {
	defaultPageSize: 100,
	mobileDefaultPageSize: 10
}